import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Libraries16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.25 3C0.25 2.30964 0.809644 1.75 1.5 1.75H4C4.17778 1.75 4.34688 1.78711 4.5 1.85401C4.65312 1.78711 4.82222 1.75 5 1.75H7.5C8.02471 1.75 8.47392 2.0733 8.65927 2.53157L10.8406 1.90834C11.4771 1.72647 12.1451 2.07245 12.3638 2.69731L15.5329 11.7518C15.7704 12.4305 15.3878 13.1692 14.6965 13.3667L12.1596 14.0915C11.5231 14.2734 10.8551 13.9274 10.6364 13.3025L8.75 7.91277V13C8.75 13.6904 8.19036 14.25 7.5 14.25H5C4.82222 14.25 4.65312 14.2129 4.5 14.146C4.34689 14.2129 4.17778 14.25 4 14.25H1.5C0.809644 14.25 0.25 13.6904 0.25 13V3ZM3.75 12.75V3.25H1.75V12.75H3.75ZM5.25 12.75H7.25V3.25H5.25V12.75ZM11.0259 3.41541L8.97067 4.00263L11.9743 12.5844L14.0296 11.9972L11.0259 3.41541Z'
      fill='currentColor'
    />
  </Svg>
);

Libraries16.displayName = 'Libraries16';
export default Libraries16;
